import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconComponent } from '@montebravo.tech/design-system-icons';
import { NgxFileDropModule } from 'ngx-file-drop';
import { SnackBarService } from '../../services/snack-bar.service';
import { SnackBarComponent } from '../snackbar/snackbar.component';
import { UploadFileMultiTabComponent } from './upload-file-multi-tab.component';

@NgModule({
    declarations: [UploadFileMultiTabComponent],
    imports: [
        CommonModule,
        NgxFileDropModule,
        SnackBarComponent,
        IconComponent,
    ],
    exports: [UploadFileMultiTabComponent],
    providers: [SnackBarService],
})
export class UploadFileMultiTabModule {}
